import { DashboardFilters } from '../../dashboard/filters/dashboard-filters.model';
import { Moment } from 'moment';
import * as _ from 'lodash';
import * as moment from 'moment';
import { PaymentType, PayCustomerItemStatus } from '../../../shared/enums/smarthub-enums';
import { PayInfoView } from '../pay-info-view.model';
import { PayRefundStatus } from '../../stale-dated-checks-info/stale-dated-check-view.model';

export class PayInfoFilters {
  public static enableEePayAssemblingStatus = false;

  public static readonly supportedPaymentTypes = [PaymentType.Check, PaymentType.DirectDeposit];

  private _originalDashboardFilters: DashboardFilters;
  public fromDateInvalid = false;
  public toDateInvalid = false;

  constructor(
    public dashboardFilters: DashboardFilters = null,
    public payDateTo: Moment = null,
    public view: PayInfoView,
    public paymentTypes: PaymentType[] = [],
    public amount: number = null,
    public employeeNumbers: string[] = [],
    public firstNames: string[] = [],
    public lastNames: string[] = [],
    public itemNumber: string = null,
    public statuses: PayCustomerItemStatus[] = []
  ) {
    this._originalDashboardFilters = dashboardFilters;
    this.dashboardFilters = _.clone(dashboardFilters);
  }

  get includeCheck(): boolean {
    return this.paymentTypes && this.paymentTypes.includes(PaymentType.Check);
  }
  set includeCheck(val: boolean ) {
    const otherTypes = (this.paymentTypes || []).filter(p => p !== PaymentType.Check);
    this.paymentTypes = val ? otherTypes.concat(PaymentType.Check) : otherTypes;
  }
  get includeDirectDeposit(): boolean {
    return this.paymentTypes && this.paymentTypes.includes(PaymentType.DirectDeposit);
  }
  set includeDirectDeposit(val: boolean ) {
    const otherTypes = (this.paymentTypes || []).filter(p => p !== PaymentType.DirectDeposit);
    this.paymentTypes = val ? otherTypes.concat(PaymentType.DirectDeposit) : otherTypes;
  }

  static getStatusTextKey(status: PayCustomerItemStatus): string {
    switch (status) {
      case PayCustomerItemStatus.CollectionCollected:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_COLLECTED';
      case PayCustomerItemStatus.CollectionHold:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_HOLD';
      case PayCustomerItemStatus.CollectionInTransit:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_IN_TRANSIT';
      case PayCustomerItemStatus.CollectionPartiallyCollected:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_PARTIALLY_COLLECTED';
      case PayCustomerItemStatus.CollectionPending:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_PENDING';
      case PayCustomerItemStatus.CollectionReady:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_READY';
      case PayCustomerItemStatus.CollectionReturned:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_RETURNED';
      case PayCustomerItemStatus.CollectionVoided:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_COLLECTION_VOIDED';
      case PayCustomerItemStatus.PayCanceledBeforePaid:
      case PayCustomerItemStatus.PayCanceledAfterPaid:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_CANCELED';
      case PayCustomerItemStatus.PayStopRequested:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_STOP_REQUESTED';
      case PayCustomerItemStatus.PayStopInProgress:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_STOP_IN_PROGRESS';
      case PayCustomerItemStatus.PayCheckPosted:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_CHECK_POSTED';
      case PayCustomerItemStatus.PayDeleted:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_DELETED';
      case PayCustomerItemStatus.PayIgnored:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_IGNORED';
      case PayCustomerItemStatus.PayNotPayable:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_NOT_PAYABLE';
      case PayCustomerItemStatus.PayRejected:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_REJECTED';
      case PayCustomerItemStatus.PayReturned:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_RETURNED';
      case PayCustomerItemStatus.PayReversed:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_REVERSED';
      case PayCustomerItemStatus.PayUnsuccessfulReversal:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_UNSUCCESSFUL_REVERSAL';
      case PayCustomerItemStatus.PayWithCannotPayFlag:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_CANNOT_PAY';
      case PayCustomerItemStatus.PayWithCannotCollectFlag:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_CANNOT_COLLECT';
      case PayCustomerItemStatus.PaymentGenerating:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_GENERATING';
      case PayCustomerItemStatus.PaymentHold:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_HOLD';
      case PayCustomerItemStatus.PaymentCheckPaid:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_CHECKPAID';
      case PayCustomerItemStatus.PaymentDDPaid:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_DDPAID';
      case PayCustomerItemStatus.PaymentProcessingUndoVoid:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_PROCESSING_UNDO_VOID';
      case PayCustomerItemStatus.PaymentProcessingVoid:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_PROCESSING_VOID';
      case PayCustomerItemStatus.PaymentReady:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_READY';
      case PayCustomerItemStatus.PaymentVoided:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYMENT_VOIDED';
      case PayCustomerItemStatus.PayrollOpen:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYROLL_OPEN';
      case PayCustomerItemStatus.StuckInAssembling:
        return PayInfoFilters.enableEePayAssemblingStatus
          ? 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_STUCK_IN_ASSEMBLING'
          : 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAYROLL_OPEN';
      case PayCustomerItemStatus.Unknown:
      default:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_UNKNOWN';
    }
  }

  static getStatusDescriptionKey(status: PayCustomerItemStatus): string {
    return PayInfoFilters.getStatusTextKey(status) + '_DESCRIPTION';
  }

  static compareFilters(a: PayInfoFilters, b: PayInfoFilters): boolean {
    if (!!a !== !!b) {
      return false;
    }
    if (!a) {
      return true;
    }

    if (!DashboardFilters.compareFilters(a.dashboardFilters, b.dashboardFilters)) {
      return false;
    }

    if (a.view !== b.view) {
      return false;
    }

    if (!!a.payDateTo !== !!b.payDateTo
      || moment.isMoment(a.payDateTo) !== moment.isMoment(b.payDateTo)) {
      return false;
    }

    if (a.payDateTo) {
      if (moment.isMoment(a.payDateTo)) {
        if (!a.payDateTo.isSame(b.payDateTo)) {
          return false;
        }
      } else if (a.payDateTo !== b.payDateTo) {
        return false;
      }
    }

    if (!PayInfoFilters._compareArray(a.paymentTypes, b.paymentTypes)) {
      return false;
    }

    if (a.amount !== b.amount) {
      return false;
    }

    if (!PayInfoFilters._compareArray(a.employeeNumbers, b.employeeNumbers)) {
      return false;
    }
    if (!PayInfoFilters._compareArray(a.firstNames, b.firstNames)) {
      return false;
    }
    if (!PayInfoFilters._compareArray(a.lastNames, b.lastNames)) {
      return false;
    }
    if (a.itemNumber !== b.itemNumber) {
      return false;
    }
    if (!PayInfoFilters._compareArray(a.statuses, b.statuses)) {
      return false;
    }

    return true;
  }

  private static _compareArray(a: any[], b: any[]): boolean {
    if (!a) {
      return !b || !b.length;
    }
    if (!b) {
      return !a.length;
    }

    if (a.length !== b.length) {
      return false;
    }

    const hash = {};
    for (const item of a) {
      const value = hash[item];
      if (value) {
        hash[item] = value + 1;
      } else {
        hash[item] = 1;
      }
    }

    for (const item of b) {
      if (hash[item]) {
        hash[item]--;
      } else {
        return false;
      }
    }

    return true;
  }

  copy(newDashboardFilters: DashboardFilters): PayInfoFilters {
    return new PayInfoFilters(
      newDashboardFilters,
      newDashboardFilters.payDate,
      this.view,
      this.paymentTypes.slice(),
      this.amount,
      this.employeeNumbers.slice(),
      this.firstNames.slice(),
      this.lastNames.slice(),
      this.itemNumber,
      this.statuses.slice());
  }

  clone(): PayInfoFilters {
    const newFilters = this.copy(this._originalDashboardFilters);

    newFilters.dashboardFilters = _.clone(this.dashboardFilters);
    newFilters.payDateTo = this.payDateTo;
    newFilters.fromDateInvalid = this.fromDateInvalid;
    newFilters.toDateInvalid = this.toDateInvalid;

    return newFilters;
  }

  reset() {
    this.dashboardFilters = _.clone(this._originalDashboardFilters);
    this.payDateTo = this.dashboardFilters.payDate;
    this.view = PayInfoView.EmployeePays;
    this.includeCheck = true;
    this.includeDirectDeposit = true;
    this.amount = null;
    this.employeeNumbers = [];
    this.firstNames = [];
    this.lastNames = [];
    this.itemNumber = null;
    this.statuses = [];
  }

  public areRequiredFieldsMissingForDates(): boolean {
    const missingEmpNos = this.employeeNumbers.filter(e => e && e.trim() !== '').length === 0;
    const missingNames = ((this.firstNames.filter(e => e && e.trim() !== '').length === 0) ||
                          (this.lastNames.filter(e => e && e.trim() !== '').length === 0));
    const missingDocNum = !this.itemNumber;

    return moment.isMoment(this.dashboardFilters.payDate) &&
            !this.dashboardFilters.payDate.isSame(this.payDateTo, 'day') &&
            missingEmpNos &&
            missingNames &&
            missingDocNum;
  }

  public isFromDateAfterToDate(): boolean {
    return moment.isMoment(this.dashboardFilters.payDate) &&
      this.dashboardFilters.payDate.isAfter(this.payDateTo, 'day');
  }

  public isAmountTooLow(): boolean {
    return this.amount < -10000000000000.00;
  }
  public isAmountTooBig(): boolean {
    return this.amount > 10000000000000.00;
  }

  public isFormInvalid(): boolean {
    return this.fromDateInvalid
      || this.toDateInvalid
      || this.isAmountTooBig()
      || this.isAmountTooLow()
      || this.isFromDateAfterToDate()
      || this.areRequiredFieldsMissingForDates();
  }
}
